import {Box} from '@mantine/core';
import Head from 'next/head';
import {useRouter} from 'next/router';
import type {FC} from 'react';
import {GSSKT_HOST} from '../../../config/constants/hosts';
import {SectionTitle} from '../../../shared/components/SectionTitle';

export const DisclaimerPage: FC = () => {
  const router = useRouter();
  const currentUrl = `${GSSKT_HOST}${decodeURI(router.asPath)}`;
  const TEXT_CLASSNAME = 'leading text-black-1 text-base';

  return (
    <>
      <Head>
        <title key="title">著作権・免責事項</title>
        <meta key="og:title" property="og:title" content="著作権・免責事項" />
        <meta key="og:url" property="og:url" content={currentUrl} />
        <link rel="canonical" href={currentUrl} key="canonical" />
      </Head>
      <Box className="w-full max-w-[664px]">
        <SectionTitle order={1} title="著作権・免責事項" />
        <Box className="mb-16 bg-white px-8 py-16 pc:p-32">
          <div>
            <p className={`${TEXT_CLASSNAME} mt-12`}>
              「外資就活ドットコム」及びホームページ掲載情報は、日本国の著作権法および国際条約による著作権保護の対象となっています。当ホームページの内容について、私的使用又は引用等著作権法上認められた行為を除き、「外資就活ドットコム」に無断で転載等を行うことはできません。また、引用を行う際は適宜の方法により、必ず出所を明示してください。当ホームページの内容の全部または一部について、「外資就活ドットコム」に無断で改変を行うことはできません。
            </p>
            <p className={`${TEXT_CLASSNAME} mt-12`}>
              当ホームページの掲載情報の正確性については万全を期しておりますが、「外資就活ドットコム」は利用者が当ホームページの情報を用いて行う一切の行為について何ら責任を負うものではありません。その他当ホームページは予告なしに内容を変更又は削除する場合があります。あらかじめご了承下さい。
            </p>
          </div>
        </Box>
      </Box>
    </>
  );
};
